import { render } from "./PaymentFormButton.vue?vue&type=template&id=5289b89a"
import script from "./PaymentFormButton.vue?vue&type=script&lang=js"
export * from "./PaymentFormButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__